const MANAGE_CUSTOMERS = {
  GET_CUSTOMERS: "CUSTOMERS:GET_CUSTOMERS",
};

export default MANAGE_CUSTOMERS;
